export default {"src":"/_next/static/media/washer.40bec820.svg","height":100,"width":100};